import React from 'react';
import AdminSidebar from './adminsidebar';

const AdminLayout = ({ children }) => {
  return (
    <div className="d-flex bg-light min-vh-100">
      {/* 1. THE SIDEBAR (Stays Fixed on the Left) */}
      <AdminSidebar />

      {/* 2. THE MAIN CONTENT AREA */}
      <div 
        className="flex-grow-1 p-4" 
        style={{ 
          marginLeft: '280px', // Matches Sidebar width so content isn't hidden
          transition: 'all 0.3s' 
        }}
      >
        <div className="container-fluid">
          {/* This is where your AdminDashboard or AdminAddProject will appear */}
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;